import { finish, error } from '../../../modules/selections/actions/move-selections';
import api from '../../../api';

export function request(dispatch, { eventId, marketId, data }) {
    api.patch(`/events/${eventId}/markets/${marketId}/selections/move`,
        data
    ).then(
        data => dispatch(finish(data)),
        errors => dispatch(error(errors))
    );
}